export default __webpack_public_path__ + "edit-interface-sign.png";